//@flow
import * as actionTypes from './actionTypes';
import {
    submitTaskApi,getTaskApi,getVendorsApi
} from '../../apiUtils/api';
import { transformDataToEditFormData } from './editFormData'
import { getReviewOutcome } from '../demeter/submitFormData'
import type { Dispatch$Type,ReducerState$Type } from '../genericFlowTypes'
import type { EditFormData,PostPayloadData  } from '../phobos/flowTypes'

const workflowType = 'Morpheus'

export const getTaskData=(morpheus:ReducerState$Type, jwt:string,taskAcceptedInfoId: number)=>{
    return (dispatch:Dispatch$Type) => getTaskApi(jwt,workflowType,taskAcceptedInfoId.toString())
    .then((res)=>res.json()).then((data)=>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.MORPHEUS_EDIT_VERIFY_FORM_DATA_ERROR,error: error});
        }else {
            const formData = transformDataToEditFormData(data,morpheus)
            dispatch({
                type: actionTypes.MORPHEUS_EDIT_VERIFY_FORM_DATA_SUCCESS, 
                formData: formData,reviewQuestions: data['reviewQuestions'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.MORPHEUS_EDIT_VERIFY_FORM_DATA_ERROR, error: err});
    })
}

export const invoiceSubmissionCompleted = () => {
    return { type: actionTypes.MORPHEUS_INV_SUBMITTED_COMPLETED };
}

export const invoiceSubmission = (jwt:any,taskAcceptedInfoId:number,morpheusResultset:any,morpheus:ReducerState$Type)=>{
    let payload:PostPayloadData={
        taskAcceptedInfoId:taskAcceptedInfoId
    };

    if (morpheusResultset.isInvalidDoc){
        payload.isInvalidDoc=true;
    }else {
        payload.vendorName=morpheusResultset.vendorName;
        payload.invNo=morpheusResultset.invNo;
        payload.invDate=morpheusResultset.invDate;
        payload.poNo=morpheusResultset.poNo;
        payload.total=morpheusResultset.total;
        payload.isInvalidDoc=morpheusResultset.isInvalidDoc?morpheusResultset.isInvalidDoc:false;
        payload.isOverrideVendorName=morpheusResultset.isOverrideVendorName?morpheusResultset.isOverrideVendorName:false;
    }

    if (morpheus.reviewQuestions && morpheus.reviewQuestions.length > 0){
        payload.reviewOutcome=getReviewOutcome(morpheusResultset,morpheus.reviewQuestions)
    }
    
    return (dispatch:Dispatch$Type) => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data['error']){
            dispatch({type: actionTypes.MORPHEUS_INV_SUBMIT_ERROR, error: data.error});
        }else {
            dispatch({type: actionTypes.MORPHEUS_INV_SUBMIT_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.MORPHEUS_INV_SUBMIT_ERROR, error: err});
    })
}

export const updateFormError=(error:any|null)=>{
    return { type: actionTypes.MORPHEUS_UPDATE_FORM_ERROR, formError: error }
}

export const populateVendorsList=(jwt:any)=>{
    return (dispatch:Dispatch$Type) => getVendorsApi(jwt,workflowType).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.REFRESH_MORPHEUS_VENDORS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.REFRESH_MORPHEUS_VENDORS_SUCCESS, vendors: data.vendors });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_MORPHEUS_VENDORS_ERROR, error: err});
    })
}


// WEBPACK FOOTER //
// ./src/redux/morpheus/actions.js